import React from 'react';
import { ContentLayout } from 'layout/content';
import { DossierDocumentsContainer } from 'pods/dossier/documents';
export const DossierDocumentsScene = () => {
    return (React.createElement(ContentLayout, null,
        React.createElement(DossierDocumentsContainer, null)));
};
